import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOffers } from '../../types/offers';
import { IStatsDesktopResponse } from '../../repositories/newbuilding-card/entities/stats/StatsDesktopResponse';

interface ISetHouseStatsPayload {
  houseId: number;
  stats: IStatsDesktopResponse | null;
}

const initialState: IOffers = {} as IOffers;

export const offersSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    selectHouseId: (state, action: PayloadAction<number | undefined>) => {
      state.selectedHouseId = action.payload;
    },
    setHouseStats: (state, action: PayloadAction<ISetHouseStatsPayload>) => {
      state.data = {
        ...state.data,
        [action.payload.houseId]: action.payload.stats,
      };
    },
  },
});

export const {
  reducer: offersReducer,
  actions: { selectHouseId, setHouseStats },
} = offersSlice;
